import { SortDirection } from "react-virtualized";
import { CATEGORIES_LIST, CATEGORIES_LIST_HE } from "../../fixtures/categories";
import { get } from "lodash";

const CATEGORIES_LIST_LOCAL =
  navigator.language.includes('he') ? CATEGORIES_LIST_HE : CATEGORIES_LIST;

const categories = Object.values(CATEGORIES_LIST_LOCAL).reduce((acc, item) => {
  acc[item.id] = item;
  return acc;
}, {});

const sortBy = sort => (list, direction) => {
  const sortedASC = list.sort(sort);

  if (direction === SortDirection.DESC) return sortedASC.reverse();

  return sortedASC;
};

export const sortCategory = (a, b) => {
  let category1 = { order: 1000 };
  let category2 = { order: 1000 };

  if (a.categories && a.categories.length > 0)
    category1 = categories[a.categories[0]];

  if (b.categories && b.categories.length > 0)
    category2 = categories[b.categories[0]];

  return Number(category2.order) - Number(category1.order) < 0 ? 1 : -1;
};

const sortAssignTo = (a, b) => {
  const A = get(a, "assignTo.displayName");
  const B = get(b, "assignTo.displayName");

  if (A < B) {
    return -1;
  }
  if (A > B) {
    return 1;
  }
  return 0;
};

const sortDueDate = (a, b) => {
  let orderA = (a.dueDate && +new Date(a.dueDate)) || 0;
  let orderB = (b.dueDate && +new Date(b.dueDate)) || 0;
  if (orderA < orderB) {
    return -1;
  }
  if (orderA > orderB) {
    return 1;
  }
  return 0;
};

const sortLocation = (a, b) => {
  const unnitA = a.location ? get(a, "location.unit.name") : "0-unit";
  const unnitB = b.location ? get(b, "location.unit.name") : "0-unit";

  const f = (acc, item) => {
    if (!isNaN(parseInt(item, 10))) {
      acc = parseInt(item, 10);
    }
    return acc;
  };

  let arrA = unnitA ? unnitA.split("-") : [0, 0];
  let arrB = unnitB ? unnitB.split("-"): [0, 0];

  let A = arrA.reduce(f, 0);
  let B = arrB.reduce(f, 0);

  if (A === 0) {
    const fullStrName = parseInt(a, 10);
    A = isNaN(fullStrName) ? 0 : fullStrName;
  }

  if (B === 0) {
    const fullStrName = parseInt(b, 10);
    B = isNaN(fullStrName) ? 0 : fullStrName;
  }

  if (A < B) return -1;
  if (A > B) return 1;

  if (arrA[1] < arrB[1]) return -1;
  if (arrA[1] > arrB[1]) return 1;

  return 0;
};

const sortStatus = (a, b) => {
  const stateA = a.issueState;
  const stateB = b.issueState;
  if (stateA > stateB) return -1;
  if (stateA < stateB) return 1;

  return 0;
};

const sortIssueNumber = (a, b) => {
  const stateA = a.issueNumber;
  const stateB = b.issueNumber;
  if (stateA > stateB) return -1;
  if (stateA < stateB) return 1;

  return 0;
};

export default {
  categories: sortBy(sortCategory),
  assignTo: sortBy(sortAssignTo),
  dueDate: sortBy(sortDueDate),
  location: sortBy(sortLocation),
  issueState: sortBy(sortStatus),
  createdAt: sortBy(sortDueDate),
  issueNumber: sortBy(sortIssueNumber)
};
